import { post } from '../request/request';

export default (email: string, password: string): Promise<any> =>
  post('/v1.1/authenticate', { email, password });
